"use strict";
exports.__esModule = true;
var report_option_errors_js_1 = require("./report-option-errors.js");
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var navs;
        (function (navs) {
            var reportOptions;
            (function (reportOptions) {
                var tag;
                (function (tag_1) {
                    var EntryNoNameError = report_option_errors_js_1["default"].EntryNoNameError;
                    var TagNoNameError = report_option_errors_js_1["default"].TagNoNameError;
                    /**
                     * This class is for single entry in Tags. Each tag has multiple
                     * entries. Entries can be selected.
                     */
                    var Entry = /** @class */ (function () {
                        function Entry(name, selected) {
                            if (selected === void 0) { selected = true; }
                            if (!name) {
                                throw new EntryNoNameError();
                            }
                            this.name = name.toString();
                            this.selected = selected;
                        }
                        Entry.prototype.getName = function () {
                            return this.name;
                        };
                        Entry.prototype.getState = function () {
                            return this.selected;
                        };
                        Entry.prototype.select = function () {
                            this.selected = true;
                        };
                        Entry.prototype.unselect = function () {
                            this.selected = false;
                        };
                        Entry.prototype.invert = function () {
                            this.selected = !this.selected;
                        };
                        return Entry;
                    }());
                    tag_1.Entry = Entry;
                    /**
                     * Category tag object. Each tag has multiple entries.
                     *
                     * This objects are binded to angular ng-models. So hard copy will
                     * result in digest loop problem.
                     */
                    var Tag = /** @class */ (function () {
                        function Tag(name, entries) {
                            if (entries === void 0) { entries = []; }
                            if (!name) {
                                throw new TagNoNameError();
                            }
                            this.name = name.toString();
                            this.entries = entries.filter(function (en) { return en; });
                        }
                        Tag.prototype.getName = function () {
                            return this.name;
                        };
                        Tag.prototype.getEntries = function () {
                            return this.entries.slice();
                        };
                        Tag.prototype.getSelectedEntries = function () {
                            return this.entries.filter(function (entry) { return entry.getState(); });
                        };
                        Tag.prototype.addEntry = function (entryName) {
                            this.entries.push(new Entry(entryName));
                        };
                        ;
                        Tag.prototype.setEntries = function (entries) {
                            this.entries = entries.slice();
                        };
                        Tag.prototype.selectAllEntries = function () {
                            this.entries.forEach(function (entry) { return entry.select(); });
                        };
                        ;
                        Tag.prototype.invertSelectEntries = function () {
                            this.entries.forEach(function (entry) { return entry.invert(); });
                        };
                        ;
                        /**
                         * Set entries state by given selected name list.
                         *
                         * @param selectedEntryNames {Array<string>}
                         */
                        Tag.prototype.selectEntriesByName = function (selectedEntryNames) {
                            if (selectedEntryNames === void 0) { selectedEntryNames = []; }
                            this.entries.forEach(function (entry) {
                                if (selectedEntryNames.indexOf(entry.getName()) >= 0) {
                                    entry.select();
                                }
                                else {
                                    entry.unselect();
                                }
                            });
                        };
                        ;
                        return Tag;
                    }());
                    tag_1.Tag = Tag;
                    /**
                     * List of tags.
                     *
                     * This objects are binded to angular ng-models. So hard copy will
                     * result in digest loop problem.
                     */
                    var TagList = /** @class */ (function () {
                        /**
                         * In this case tags may have duplicated names.
                         *
                         * @param tags {Array<Tag>}
                         */
                        function TagList(tags) {
                            if (tags === void 0) { tags = []; }
                            this.tags = tags.filter(function (t) { return t; });
                        }
                        /**
                         * Find all tags with given name. Most of the time the names
                         * are unique, but it is valid to have duplicated name.
                         *
                         * @param name {string}
                         * @return {Array<Tag>} Return tag if find one, otherwise undefined.
                         */
                        TagList.prototype.findTag = function (name) {
                            if (this.tags && name) {
                                // [][0] is undefined, so far.
                                return this.tags.filter(function (item) { return item.getName() === name; });
                            }
                            else {
                                return undefined;
                            }
                        };
                        /**
                         * Add a tag to list with given name if tag not exists.
                         *
                         * @param name {string}
                         * @param position {number}
                         * @return {Tag} Return the found or new tag.
                         */
                        TagList.prototype.addTagIfNotExist = function (name, position) {
                            if (position === void 0) { position = -1; }
                            var tag = this.findFirstTag(name);
                            if (!tag) {
                                tag = new Tag(name);
                                if (position < 0) {
                                    this.tags.push(tag);
                                }
                                else {
                                    this.tags.splice(position, 0, tag);
                                }
                            }
                            return tag;
                        };
                        TagList.prototype.insertTag = function (name) {
                            this.addTagIfNotExist(name, 0);
                        };
                        /**
                         * Get tags.
                         *
                         * @return {Array<Tag>}
                         */
                        TagList.prototype.getTags = function () {
                            return this.tags.slice();
                        };
                        /**
                         * Find first tag with given name.
                         * @param name {string}
                         * @return {Tag}
                         */
                        TagList.prototype.findFirstTag = function (name) {
                            var tags = this.findTag(name);
                            return tags ? tags[0] : undefined;
                        };
                        /**
                         * Generate an array of Tag objects instead of using array of
                         * strings.
                         *
                         * @param input {Array<string>} The input array, in a form of:
                         *     ["all", "test:entry1", "test:entry2"].
                         * @returns {Array<Tag>} Return an array of Tag objects.
                         */
                        TagList.prototype.loadTagsFromStringArray = function (input) {
                            var _this = this;
                            if (input === void 0) { input = []; }
                            this.tags = [];
                            // No idea whats wrong with the all.
                            // Seems it works just fine without the all tag.
                            input.forEach(function (item) {
                                if (item.indexOf(':') > 0) {
                                    // Normal tags:entries
                                    var entry = item.split(':');
                                    var tag_2 = _this.addTagIfNotExist(entry[0]);
                                    tag_2.addEntry(entry[1]);
                                }
                                else {
                                    // The weird all tag
                                }
                            });
                        };
                        TagList.prototype.resetAllTags = function () {
                            this.tags.forEach(function (tag) {
                                tag.selectAllEntries();
                            });
                        };
                        TagList.prototype.toDisplayStringList = function () {
                            // I am crazy.
                            return this.tags.map(function (tag) {
                                return tag.getSelectedEntries().map(function (entry) {
                                    return tag.getName() + ":" + entry.getName();
                                }).join(" or ");
                            }).filter(function (tagString) {
                                return tagString && tagString.trim().length;
                            }).map(function (tagString) { return "(" + tagString + ")"; }).join(" and ");
                        };
                        return TagList;
                    }());
                    tag_1.TagList = TagList;
                })(tag = reportOptions.tag || (reportOptions.tag = {}));
            })(reportOptions = navs.reportOptions || (navs.reportOptions = {}));
        })(navs = r6.navs || (r6.navs = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.navs.reportOptions.tag;
//# sourceMappingURL=report-option-tags.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options/app/js/logic/report-option-tags.js